module.exports = __webpack_public_path__ + "3c15813a9c48b75ab020a2468f206027.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-15.png
// module id = 2249
// module chunks = 0